module.exports = __webpack_public_path__ + "static/media/plus-circle.ed3bc4c0.svg";